import React, { useEffect, useState } from "react";
import { Zap } from "lucide-react";
import { api } from "../../lib/api";

export const EarlyAccessPanel = () => {
  const [signups, setSignups] = useState(null);

  useEffect(() => {
    api.get("/early-access").then((r) => setSignups(r.data.signups)).catch(() => setSignups([]));
  }, []);

  return (
    <div data-testid="early-access-panel">
      <div className="flex items-center gap-2 mb-6">
        <Zap className="w-4 h-4" strokeWidth={1.5} />
        <p className="label" data-testid="early-access-count">
          {signups === null ? "Loading…" : `${signups.length} signup${signups.length === 1 ? "" : "s"}`}
        </p>
      </div>
      {signups !== null && signups.length === 0 && (
        <p className="text-[#3A4150]" data-testid="early-access-empty">No signups yet. Buyers can join the early access list from the order confirmation page.</p>
      )}
      {signups !== null && signups.length > 0 && (
        <div className="border border-[#D4D7DD] divide-y divide-[#D4D7DD]">
          {signups.map((s) => (
            <div key={s.email} data-testid="early-access-row" className="flex items-center justify-between px-5 py-4 bg-[#EDEEF1]">
              <span className="text-sm">{s.email}</span>
              <span className="label text-[#8A8F99]">
                {s.source === "footer" ? "Site · " : s.session_id ? "Buyer · " : ""}
                {new Date(s.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
